<template>
  <div class='EnbItemImg01' @click="Select">
    <div class="sold-out" v-if="data.gerEstoque && data.estoque <= 0 && data.tipo !== 'Variável'">Esgotado</div>
    <img v-if="data.img.length" :src="api + data.img[0].img">
    <img-icon
    v-if="!data.img.length"
    :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
    />
    <!-- <input type="file" @change="inFile"/> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'EnbItemImg01',
  components: { ImgIcon },
  props: ['data'],
  mixins: [api],
  computed: {
    estoqueVariavel () {
      return this.data.estoqueVariavel.map(e => e.src.quantidade).reduce((p, c) => parseFloat(c) + parseFloat(p), 0)
    }
  },
  methods: {
    ...mapActions(['SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then( async () => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/loja/${this.$route.params.categ}/${this.data.link}`)
          } else {
            this.$router.push(`/${this.data.link}`)
          }
        })
    },
    inFile (e) {
      this.getBase64(e.target.files[0])
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        console.log(reader.result)
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    }
  }
}
</script>

<style scoped>
.EnbItemImg01 {
  width: 200px;
  height: 180px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

img {
  width: 200px;
  height: 180%;
  cursor: pointer;
  animation: ZoomOut 0.2s forwards;
}

img:hover {
  animation: ZoomIn 0.2s forwards;
}

.sold-out {
  font-size: 10px;
  position: absolute;
  color: #FFFFFF;
  padding: 1%;
  background-color: red;
  border-radius: 5px;
  border: 2px solid #FFFFFF;
  margin-top: 5%;
}

/* card mais estreito que 200px: a imagem acompanha a largura do card (o zoom usa px fixos, então fica desligado) */
@media (max-width: 500px) {
  .EnbItemImg01 {
    width: 100%;
  }
  img,
  img:hover {
    width: 100%;
    height: 180px;
    object-fit: cover;
    animation: none;
  }
}

@keyframes ZoomIn {
  0% {
    width: 200px;
    height: 180px;
    margin-left: 0px;
    margin-top: 0px;
  }
  100% {
    width: 220px;
    height: 200px;
    margin-left: -10px;
    margin-top: -10px;
  }
}

@keyframes ZoomOut {
  0% {
    width: 220px;
    height: 200px;
    margin-left: -10px;
    margin-top: -10px;
  }
  100% {
    width: 200px;
    height: 180px;
    margin-left: 0px;
    margin-top: 0px;
  }
}
</style>
